export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <span className="inline-block px-4 py-2 border border-gray-300 rounded-full text-xs font-semibold text-gray-600 uppercase tracking-wider">
            WHO WE ARE
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
          {/* Left Column */}
          <div>
            <h2 className="text-5xl font-extrabold text-gray-900 mb-3 leading-tight">
              Building Digital
            </h2>
            <h2 className="text-5xl font-normal text-purple-700 mb-12 leading-tight flex items-center gap-3">
              Security Solutions
              <span className="text-4xl">🛡️</span>
            </h2>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                STYLINE DOO POZAREVAC is a Serbian technology company dedicated to protecting your digital privacy. We believe that everyone deserves secure, unrestricted access to the internet without compromising their personal data.
              </p>
              <p>
                Our VPN solution combines cutting-edge encryption technology with user-friendly design, ensuring that your online activities remain private and secure. With servers strategically located across the globe, we provide fast, reliable connections wherever you are.
              </p>
              <p>
                Built by security experts and trusted by users worldwide, STYLINE VPN represents our commitment to making the internet a safer place for everyone.
              </p>
            </div>

            <a
              href="#features"
              className="inline-block mt-10 text-blue-600 font-semibold underline hover:text-blue-700 transition-colors"
            >
              Learn more about our technology →
            </a>
          </div>

          {/* Right Column */}
          <div className="space-y-16">
            <div>
              <div className="text-6xl font-extrabold text-gray-900 mb-2">256-bit</div>
              <div className="text-sm text-gray-600 uppercase tracking-wide">Encryption Standard</div>
            </div>

            <div>
              <div className="text-6xl font-extrabold text-purple-700 mb-2">50+</div>
              <div className="text-sm text-gray-600 uppercase tracking-wide">Global Server Locations</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
